import Joi from "joi";
import errorsResolver from "../schemeUtils";
import { viewReports } from "../../helpers/data-constants";

let documentAndDepartments = {

  documentNumber: Joi.number()
    .required().empty('')
    .max(999999999)
    .min(0)
    .integer()
    .error(errorsResolver({
      numberUnsafe: `Номер документа должен быть меньше 10 символов`,
      numberMin: `Номер документа должен больше нуля`,
      numberMax: `Номер документа должен быть меньше 10 символов`,
      number: `Номер документа должен быть числом`,
      required: `Номер документа обязательное поле`,
    })),
  departments: Joi.object({
    label: Joi.string()
      .required('')
      .error(errorsResolver({
        required: `Подразделение обязательное поле`,
      })),
    value: Joi.number()
      .error(errorsResolver({
        number: `Должно быть число`
      }))
  })
    .invalid(null)
    .required()
    .min(1)
    .error(errorsResolver({
      invalid: `Подразделение обязательное поле`,
      required: `Подразделение обязательное поле`,
      min: `Подразделение обязательное поле`
    }))

}

export const reportScheme = (isNonCashOperation) => {
  const schema = {
    ...documentAndDepartments,

    date: Joi.date()
      .required()
      .iso()
      .error(errorsResolver({
        dateFormat: `Некорректная дата`
      }))
  };

  if (isNonCashOperation) {
    schema.cashType = Joi.object({
      label: Joi.string(),
      value: Joi.string()
    });
  }

  return Joi.object(schema);
};

export const reportDateRangeScheme = (reportType) => {
  const baseSchema = Joi.object({
    ...documentAndDepartments,
  });
  switch (reportType) {
    case viewReports.CLIENTS_REPORT:
      return clientReportSchema;
    case viewReports.OPERATIONS_REPORT:
      return operationReportSchema;
    default:
      return baseSchema;
  }
}

export const clientReportSchema = Joi.object({
  cashBoxIdFilter: Joi.array().items(Joi.object({
    label: Joi.string(),
    value: Joi.number()
  })),
  branchIdFilter: Joi.array().items(Joi.object({
    label: Joi.string(),
    value: Joi.number()
  })),
  allBranches: Joi.boolean(),
  clientStatus: Joi.object({
    label: Joi.string()
      .required()
      .error(errorsResolver({
        required: 'Статус клиента обязательное поле',
      })),
    value: Joi.string()
  }).required()
    .error(errorsResolver({
      required: 'Статус клиента обязательное поле',
    }))
})

export const operationReportSchema = Joi.object({
  cashBoxIdFilter: Joi.array().items(Joi.object({
    label: Joi.string(),
    value: Joi.number()
  })),
  branchIdFilter: Joi.array().items(Joi.object({
    label: Joi.string(),
    value: Joi.number()
  })),
  allBranches: Joi.boolean(),
})

export const monitoringOfBalancesScheme = Joi.object({
    allBranches: Joi.bool(),
    branch: Joi.when('allBranches', {
        is: false,
        then: Joi.object({
            label: Joi.string()
                .max(100)
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- ]*$'))
                .required()
                .error(errorsResolver({
                    max: `Филиал должно быть до ${100} символов`,
                    required: `Филиал обязательное поле`,
                    pattern: `Филиал содержит некорректные символы`,
                    any: `Филиал обязателен`
                })),
            value: Joi.any()
        }).required()
            .error(errorsResolver({
            max: `Филиал должно быть до ${100} символов`,
            required: `Выберите филиал или все филиалы`,
            pattern: `Филиал содержит некорректные символы`,
            any: `Филиал обязателен`
        })),
        otherwise: Joi.object({
            label: Joi.string()
                .max(100)
                .allow('')
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- ]*$'))
                .error(errorsResolver({
                    max: `Филиал должно быть до ${100} символов`,
                    pattern: `Филиал содержит некорректные символы`
                })),
            value: Joi.any()
        })
    }),
    date: Joi.date()
        .required()
        .iso()
        .error(errorsResolver({
            dateFormat: `Некорректная дата`
        }))
});